import { CakeTopologyBidirectionalDirection, CakeTopologyStateSnapshot } from '../models/ef-cake-topology.model';

export abstract class EFateConstants {
  public static readonly MAX_NODE_NAME_LENGTH = 12;
  public static readonly NODE_LABEL_MAX_VISIBLE_LENGTH = 6;
  public static readonly MAX_GROUP_NAME_LENGTH = 25;
  public static readonly MAX_CAKE_GROUPS = 5;

  public static readonly GROUP_KEY_PREFIX = 'group-';
  public static readonly DEFAULT_GROUP_KEY: string = 'group-1';
  public static readonly DEFAULT_TOPOLOGY_KEY = 'default-topology';
  public static readonly DEFAULT_MODEL_ID = 'ef-model-001';
  public static readonly DEFAULT_GEOGRAPHY = 'CAKE';
  public static readonly DEFAULT_GROUP_NAME_PREFIX = 'Group';
  public static readonly PAYLOAD_LOG_LABEL = 'EF Cake Topology Save Payload';

  public static readonly GROUP_COLORS = ['#7ad2de', '#f4b3b3', '#bfecc0', '#d9c7f8', '#f7d3a4'];
  public static readonly TOPOLOGY_NODE_KEYS: string[] = ['Parent', 'A1', 'A2', 'A3', 'B1', 'B2', 'C1'];

  public static readonly DATA_PERCENT_DECIMALS = 2;
  public static readonly MAX_DATA_SET_NAME_LENGTH = 200;

  public static readonly NODE_KEY_TO_PERCENT_FIELD: Record<string, string> = {
    Parent: 'parentPercent',
    A1: 'a1Percent',
    A2: 'a2Percent',
    A3: 'a3Percent',
    B1: 'b1Percent',
    B2: 'b2Percent',
    C1: 'c1Percent',
  };

  public static readonly CAKE_STUDY_TYPES: string[] = [
    'Aerobic Soil',
    'Aerobic Aquatic (Water/Sediment)',
    'Anaerobic Soil',
    'Anaerobic Aquatic (Water/Sediment)',
    'Aqueous Photolysis',
    'Flooded Aerobic Soil',
    'Hydrolysis',
    'Soil Photolysis',
  ];

  public static readonly DEFAULT_NODE_NAMES = {
    Parent: 'Parent',
    A1: 'A1',
    A2: 'A2',
    A3: 'A3',
    B1: 'B1',
    B2: 'B2',
    C1: 'C1',
  };

  public static readonly DEFAULT_BIDIRECTIONAL_EDGE_DIRECTIONS: Record<string, CakeTopologyBidirectionalDirection> = {
    'a1-b1': 'none',
    'b1-c1': 'none',
    'a2-b2': 'none',
  };

  public static readonly DEFAULT_ACTIVE_STATUS_NODES: string[] = ['status-parent'];

  public static readonly EDGE_TO_SOURCE_NODE: Record<string, string> = {
    'parent-a1': 'Parent',
    'parent-b1': 'Parent',
    'parent-c1': 'Parent',
    'a1-a2': 'A1',
    'a2-a3': 'A2',
    'b1-b2': 'B1',
    'b1-a2': 'B1',
  };

  public static readonly EDGE_TO_TARGET_NODE: Record<string, string> = {
    'parent-a1': 'A1',
    'parent-b1': 'B1',
    'parent-c1': 'C1',
    'a1-a2': 'A2',
    'a2-a3': 'A3',
    'b1-b2': 'B2',
    'b1-a2': 'A2',
  };

  public static readonly BIDIRECTIONAL_EDGE_NODES: Record<string, { from: string; to: string }> = {
    'a1-b1': { from: 'A1', to: 'B1' },
    'b1-c1': { from: 'B1', to: 'C1' },
    'a2-b2': { from: 'A2', to: 'B2' },
  };

  public static readonly STATUS_NODE_TO_OWNER_NODE: Record<string, string> = {
    'status-parent': 'Parent',
    'status-a1': 'A1',
    'status-b1': 'B1',
    'status-c1': 'C1',
    'status-a2': 'A2',
    'status-b2': 'B2',
    'status-a3': 'A3',
  };

  public static createDefaultSnapshot(): CakeTopologyStateSnapshot {
    return {
      activeEdges: [],
      bidirectionalEdges: { ...EFateConstants.DEFAULT_BIDIRECTIONAL_EDGE_DIRECTIONS },
      activeStatusNodes: [...EFateConstants.DEFAULT_ACTIVE_STATUS_NODES],
    };
  }

  public static readonly BIDIRECTIONAL_EDGE_DIRECTIONS: {
    readonly NONE: CakeTopologyBidirectionalDirection;
    readonly FORWARD: CakeTopologyBidirectionalDirection;
    readonly REVERSE: CakeTopologyBidirectionalDirection;
  } = {
    NONE: 'none',
    FORWARD: 'forward',
    REVERSE: 'reverse',
  };
}
